<template>
  <div class="modal-box">
    <div class="modal-title">
      <h3>Nieuwe Klant</h3>
      <div class="flex-divider"></div>
      <base-button type="secondary" @click="closeModal">
        <base-icon iconRef="close" />
      </base-button>
    </div>
    <div class="modal-content">
      <div class="modal-content-section">
        <div class="input-header">
          <h4>Basisgegevens</h4>
        </div>
        <div class="input-container">
          <label for="clientName" class="label required">Klantnaam</label>
          <base-input
            type="text"
            id="clientName"
            name="clientName"
            placeholder="Klantnaam"
            v-model="newClientData.clientName"
            data-vv-as="Klantnaam"
            v-validate="'required'"
          />
          <base-input-warning :error="errors.first('clientName')" />
        </div>
        <div class="input-container">
          <label for="clientDescription" class="label">Beschrijving</label>
          <textarea
            id="clientDescription"
            class="input"
            rows="4"
            v-model="newClientData.description"
          ></textarea>
        </div>
        <div class="input-container">
          <label class="label required">Sales eigenaar</label>
          <select
            class="input"
            name="salesOwner"
            id="salesOwner"
            v-model="newClientData.salesOwner"
            data-vv-as="Sales eigenaar"
            v-validate="'required'"
          >
            <option :value="username" v-for="username in usersNames" :key="username">{{username}}</option>
          </select>
          <base-input-warning :error="errors.first('salesOwner')" />
        </div>
      </div>
      <div class="modal-content-section">
        <div class="input-header">
          <h4>Contactpersoon</h4>
        </div>
        <div class="input-row">
          <div class="input-container">
            <label class="label" for="contactFirstName">Voornaam</label>
            <base-input
              type="text"
              id="contactFirstName"
              name="contactFirstName"
              placeholder="Voornaam"
              v-model="newClientData.contactFirstName"
            />
          </div>
          <div class="input-container">
            <label class="label" for="contactLastName">Achternaam</label>
            <base-input
              type="text"
              id="contactLastName"
              name="contactLastName"
              placeholder="Achternaam"
              v-model="newClientData.contactLastName"
            />
          </div>
        </div>
        <div class="input-container">
          <label class="label">E-mail</label>
          <base-input type="email" placeholder="Email" v-model="newClientData.contactEmail" />
        </div>
        <div class="input-container">
          <label class="label">Telefoonnummer</label>
          <base-input type="tel" placeholder="0612345678" v-model="newClientData.contactTel" />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="flex-divider"></div>
      <base-button @click="closeModal" type="secondary">Annuleren</base-button>
      <base-button @click="createClient" :loading="creatingClient" :disabled="creatingClient">
        <base-icon iconRef="checkmark" position="left" />Aanmaken
      </base-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "client-create-modal",
  data() {
    return {
      creatingClient: false,
      newClientData: {
        clientName: "",
        description: "",
        contactFirstName: "",
        contactLastName: "",
        contactEmail: "",
        contactTel: "",
        salesOwner: "",
      },
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters.getUsersList.find((user) => {
        return user.data().uid == this.$store.getters.getUser.uid;
      });
    },
    currentUserFullName() {
      return (
        this.currentUser.data().firstName +
        " " +
        this.currentUser.data().lastName
      );
    },
    usersList() {
      return this.$store.getters.getUsersList;
    },
    usersNames() {
      const usersNames = [];
      this.usersList
        .filter((user) => {
          return user.data().includeInMeasurements;
        })
        .forEach((user) => {
          usersNames.push(user.data().firstName + " " + user.data().lastName);
        });
      return usersNames;
    },
  },
  methods: {
    createClient() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.creatingClient = true;
          const newClient = this.$createNewClient(this.newClientData);
          this.$firestore
            .collection("clients")
            .add(newClient)
            .then((doc) => {
              this.creatingClient = false;
              this.closeModal();
              this.$router.push("/klant/" + doc.id);
            });
        }
      });
    },
    closeModal() {
      this.$store.commit("setModalShown", {
        dataType: "client",
        modalType: "create",
        shown: false,
      });
    },
  },
  mounted() {
    if (
      this.usersNames.find((username) => username == this.currentUserFullName)
    ) {
      this.newClientData.salesOwner = this.currentUserFullName;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modal-components/client-create-modal.vue